import React from 'react';
import { ethers } from 'ethers';
import { CONTRACT_ADDRESS, CONTRACT_ABI } from '../constants';

const ConnectWallet = ({ setProvider, setSigner, setContract, setAccount, account }) => {
  const connectWallet = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        // Request account access
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);
        
        console.log("Contract instance:", contract);
        console.log("Contract functions:", Object.keys(contract.functions));
        console.log("Offers function:", contract.offers);

        const accounts = await provider.listAccounts();
        
        setProvider(provider);
        setSigner(signer);
        setContract(contract);
        setAccount(accounts[0]);

        // Check if the user is on the Scroll Sepolia network
        const network = await provider.getNetwork();
        if (network.chainId !== 534351) {
          await switchToScrollSepolia();
        }
      } catch (error) {
        console.error('Error connecting wallet:', error);
      }
    } else {
      alert('Please install MetaMask!');
    }
  };

  const switchToScrollSepolia = async () => {
    try {
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: '0x8274f' }], // 534351 in hexadecimal
      });
    } catch (error) {
      if (error.code === 4902) {
        await addScrollSepoliaNetwork();
      } else {
        console.error('Error switching to Scroll Sepolia:', error);
      }
    }
  };

  const addScrollSepoliaNetwork = async () => {
    try {
      await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [{
          chainId: '0x8274f',
          chainName: 'Scroll Sepolia',
          nativeCurrency: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18
          },
          rpcUrls: ['https://sepolia-rpc.scroll.io/'],
          blockExplorerUrls: ['https://sepolia-blockscout.scroll.io/']
        }]
      });
    } catch (error) {
      console.error('Error adding Scroll Sepolia network:', error);
    }
  };

  const truncateAddress = (address) => {
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  return (
    <button className="connect-wallet" onClick={connectWallet}>
      {account ? truncateAddress(account) : 'Connect Wallet'}
    </button>
  );
};

export default ConnectWallet;